import React from 'react';
import { Link } from 'react-router-dom';
import clint01 from '../../assets/img/brand/client-logo-01.png';
import clint02 from '../../assets/img/brand/client-logo-02.png';
import clint03 from '../../assets/img/brand/client-logo-03.png';
import clint04 from '../../assets/img/brand/client-logo-04.png';
import clint05 from '../../assets/img/brand/client-logo-05.png';
import clint06 from '../../assets/img/brand/client-logo-06.png';
import clint07 from '../../assets/img/brand/client-logo-07.png';
import clint08 from '../../assets/img/brand/client-logo-08.png';

const clientLogos = [clint01, clint02, clint03, clint04, clint05, clint06, clint07,  clint08];

function Client() {
    return (
        <>
            <section className="client-area pt-120 pb-120 p-relative fix">
                <div className="container">
                    <div className="row justify-content-center align-items-center mb-70">
                        <div className="col-lg-6">
                            <div className="section-title center-align wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
                                <h5>sponsors</h5>
                                <h2>Happy clients trusted Gentech</h2>
                            </div>
                        </div>
                        <div className="col-lg-6"></div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                        {clientLogos.map((logo, index) => (
                            <div className="col-lg-3 col-md-3" key={index}>
                                <div className="client-item wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                                    <img src={logo} alt={`client-logo-${index + 1}`} />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="row client-content">
                        <div className="col-lg-6">
                            <div className="client-text">
                                Increase your blog's conversion rate: a comprehensive guide to designing blogs that convert visitors into customers in Gentech.
                            </div>
                        </div>
                        <div className="col-lg-6 text-right">
                            <Link to="/contact" className="btn ss-btn" data-animation="fadeInUp" data-delay=".4s">
                                <i className="fas fa-angle-right" /> next will be you!
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Client;
